/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiListSelector,
    InternalApiListSelectorFromJSON,
    InternalApiListSelectorToJSON,
    InternalApiListSelectorGroup,
    InternalApiListSelectorGroupFromJSON,
    InternalApiListSelectorGroupToJSON,
    InternalApiUpdateListSelectorGroupCommand,
    InternalApiUpdateListSelectorGroupCommandFromJSON,
    InternalApiUpdateListSelectorGroupCommandToJSON,
} from '../models';

export interface CreateSelectorGroupRequest {
    listId: string;
    internalApiUpdateListSelectorGroupCommand: InternalApiUpdateListSelectorGroupCommand;
}

export interface DeleteSelectorGroupByCodeRequest {
    listId: string;
    groupCode: string;
}

export interface FindSelectorGroupsForListRequest {
    listId: string;
}

export interface FindSelectorOptionsForListRequest {
    listId: string;
}

export interface UpdateSelectorGroupByCodeRequest {
    listId: string;
    groupCode: string;
    internalApiUpdateListSelectorGroupCommand: InternalApiUpdateListSelectorGroupCommand;
}

/**
 * 
 */
export class ScreeningSelectorsApi extends runtime.BaseAPI {

    /**
     * Creates the selector group
     */
    async createSelectorGroupRaw(requestParameters: CreateSelectorGroupRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiListSelectorGroup>> {
        if (requestParameters.listId === null || requestParameters.listId === undefined) {
            throw new runtime.RequiredError('listId','Required parameter requestParameters.listId was null or undefined when calling createSelectorGroup.');
        }

        if (requestParameters.internalApiUpdateListSelectorGroupCommand === null || requestParameters.internalApiUpdateListSelectorGroupCommand === undefined) {
            throw new runtime.RequiredError('internalApiUpdateListSelectorGroupCommand','Required parameter requestParameters.internalApiUpdateListSelectorGroupCommand was null or undefined when calling createSelectorGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/{listId}/screening-selector-groups`.replace(`{${"listId"}}`, encodeURIComponent(String(requestParameters.listId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiUpdateListSelectorGroupCommandToJSON(requestParameters.internalApiUpdateListSelectorGroupCommand),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiListSelectorGroupFromJSON(jsonValue));
    }

    /**
     * Creates the selector group
     */
    async createSelectorGroup(requestParameters: CreateSelectorGroupRequest, initOverrides?: RequestInit): Promise<InternalApiListSelectorGroup> {
        const response = await this.createSelectorGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes the selector group
     */
    async deleteSelectorGroupByCodeRaw(requestParameters: DeleteSelectorGroupByCodeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.listId === null || requestParameters.listId === undefined) {
            throw new runtime.RequiredError('listId','Required parameter requestParameters.listId was null or undefined when calling deleteSelectorGroupByCode.');
        }

        if (requestParameters.groupCode === null || requestParameters.groupCode === undefined) {
            throw new runtime.RequiredError('groupCode','Required parameter requestParameters.groupCode was null or undefined when calling deleteSelectorGroupByCode.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/{listId}/screening-selector-groups/{groupCode}`.replace(`{${"listId"}}`, encodeURIComponent(String(requestParameters.listId))).replace(`{${"groupCode"}}`, encodeURIComponent(String(requestParameters.groupCode))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes the selector group
     */
    async deleteSelectorGroupByCode(requestParameters: DeleteSelectorGroupByCodeRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteSelectorGroupByCodeRaw(requestParameters, initOverrides);
    }

    /**
     * Fetches all active selector configurations for organisation
     */
    async findAllSelectorsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiListSelector>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/screening-selectors`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiListSelectorFromJSON));
    }

    /**
     * Fetches all active selector configurations for organisation
     */
    async findAllSelectors(initOverrides?: RequestInit): Promise<Array<InternalApiListSelector>> {
        const response = await this.findAllSelectorsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Fetches the active versions of a selector groups for a specific list
     */
    async findSelectorGroupsForListRaw(requestParameters: FindSelectorGroupsForListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiListSelectorGroup>>> {
        if (requestParameters.listId === null || requestParameters.listId === undefined) {
            throw new runtime.RequiredError('listId','Required parameter requestParameters.listId was null or undefined when calling findSelectorGroupsForList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/{listId}/screening-selector-groups`.replace(`{${"listId"}}`, encodeURIComponent(String(requestParameters.listId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiListSelectorGroupFromJSON));
    }

    /**
     * Fetches the active versions of a selector groups for a specific list
     */
    async findSelectorGroupsForList(requestParameters: FindSelectorGroupsForListRequest, initOverrides?: RequestInit): Promise<Array<InternalApiListSelectorGroup>> {
        const response = await this.findSelectorGroupsForListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches all active selectors with options for a specific list
     */
    async findSelectorOptionsForListRaw(requestParameters: FindSelectorOptionsForListRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiListSelector>>> {
        if (requestParameters.listId === null || requestParameters.listId === undefined) {
            throw new runtime.RequiredError('listId','Required parameter requestParameters.listId was null or undefined when calling findSelectorOptionsForList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/{listId}/screening-selectors`.replace(`{${"listId"}}`, encodeURIComponent(String(requestParameters.listId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiListSelectorFromJSON));
    }

    /**
     * Fetches all active selectors with options for a specific list
     */
    async findSelectorOptionsForList(requestParameters: FindSelectorOptionsForListRequest, initOverrides?: RequestInit): Promise<Array<InternalApiListSelector>> {
        const response = await this.findSelectorOptionsForListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the selector group
     */
    async updateSelectorGroupByCodeRaw(requestParameters: UpdateSelectorGroupByCodeRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiListSelectorGroup>> {
        if (requestParameters.listId === null || requestParameters.listId === undefined) {
            throw new runtime.RequiredError('listId','Required parameter requestParameters.listId was null or undefined when calling updateSelectorGroupByCode.');
        }

        if (requestParameters.groupCode === null || requestParameters.groupCode === undefined) {
            throw new runtime.RequiredError('groupCode','Required parameter requestParameters.groupCode was null or undefined when calling updateSelectorGroupByCode.');
        }

        if (requestParameters.internalApiUpdateListSelectorGroupCommand === null || requestParameters.internalApiUpdateListSelectorGroupCommand === undefined) {
            throw new runtime.RequiredError('internalApiUpdateListSelectorGroupCommand','Required parameter requestParameters.internalApiUpdateListSelectorGroupCommand was null or undefined when calling updateSelectorGroupByCode.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/{listId}/screening-selector-groups/{groupCode}`.replace(`{${"listId"}}`, encodeURIComponent(String(requestParameters.listId))).replace(`{${"groupCode"}}`, encodeURIComponent(String(requestParameters.groupCode))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiUpdateListSelectorGroupCommandToJSON(requestParameters.internalApiUpdateListSelectorGroupCommand),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiListSelectorGroupFromJSON(jsonValue));
    }

    /**
     * Updates the selector group
     */
    async updateSelectorGroupByCode(requestParameters: UpdateSelectorGroupByCodeRequest, initOverrides?: RequestInit): Promise<InternalApiListSelectorGroup> {
        const response = await this.updateSelectorGroupByCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
